export function wIREFRAUDRR() {
return [   //2024 Release 2025-08-19 12:49:10
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 198.731,
   left: 169.68,
   width: 349.20,
   height: 14.389
}
,
{
   page: 0,
   name: "signature agent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 477.82,
   left: 71.3458,
   width: 150.0002,
   height: 15.455
}
,
{
   page: 0,
   name: "date agent signs", 
   fontSize: 9,
   type: "date",
   top: 477.82,
   left: 356.729,
   width: 71.454,
   height: 14.146
}
] }